/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { SyntheticEvent, useState } from "react";

import { useTranslation } from "react-i18next";

import { CompaniesDto } from "../../../../../../../../shared";
import Autocomplete from "../../../../../../../Autocomplete/Autocomplete";
import { useStyles } from "../../../../../../styles";
import useCompanies from "../../../../hooks/useCompanies";

interface RootCompanyProps {
  isDisabled: boolean;
  userRootCompany: CompaniesDto;
  handleChangeSelection: (
    value: string,
    shouldQueryData?: boolean
  ) => Promise<void>;
}

const RootCompany = ({
  isDisabled,
  userRootCompany,
  handleChangeSelection
}: RootCompanyProps) => {
  const { t } = useTranslation();
  const { rootCompanyList } = useCompanies();

  const [selectedRootCompany, setSelectedRootCompany] =
    useState(userRootCompany);

  const { rootCompanyDiv } = useStyles();

  const handleRootCompanyChange = async (value: CompaniesDto) => {
    setSelectedRootCompany(value);

    handleChangeSelection(value?.id, true);
  };

  return (
    <div css={css(rootCompanyDiv)}>
      <Autocomplete
        size="medium"
        labelLeft={t("Selector##client company")}
        fullWidth
        disableClearable
        value={selectedRootCompany}
        options={rootCompanyList}
        getOptionLabel={option => option?.name}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        onChange={(_: SyntheticEvent, value: CompaniesDto) =>
          handleRootCompanyChange(value)
        }
        disabled={isDisabled}
      />
    </div>
  );
};

export default RootCompany;
